import { render, staticRenderFns } from "./MobileTradeNews.vue?vue&type=template&id=4cc01c56&scoped=true&"
import script from "./MobileTradeNews.vue?vue&type=script&lang=ts&"
export * from "./MobileTradeNews.vue?vue&type=script&lang=ts&"
import style0 from "./MobileTradeNews.vue?vue&type=style&index=0&id=4cc01c56&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc01c56",
  null
  
)

export default component.exports